import api from '../../api/api'

const state = {
  all: []
}

// getters
const getters = {}

// actions
const actions = {
  getAllTour ({ commit }) {
    api.getTour(tour => {
      commit('setTour', tour)
    })
  },
  addTour (context, tour) {
    return api.addTour(tour, function (data) {
      context.commit('getAllTour')
    })
  },
  updateTour (context, tour) {
    return api.updateTour(tour, function (data) {
      context.commit('getAllTour')
    })
  },
  deleteTour (context, tour) {
    return api.deleteTour(tour, function (data) {
      context.commit('getAllTour')
    })
  }
}
const mutations = {
  updateTour (state, tour) {
    this.dispatch('updateTour', tour)
  },
  deleteTour (state, tour) {
    this.dispatch('deleteTour', tour)
  },
  setTour (state, tour) {
    state.all = tour
  },
  getAllTour () {
    this.dispatch('getAllTour')
  },
  addTour (state, options) {
    this.dispatch('addTour', options)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/tour.js